<template>
    <div>
        <div class="herd">
            <div class="list">学校详情</div>
        </div>

        <div class="content">
            <div class="goods">
                <div>
                    <div class="condition">
                        学校名称：<!--<el-input disabled v-model="userInfo.schoolName"  class="input-with-select" style="max-width: 200px"> 
                        </el-input> --><span>{{ userInfo.schoolName }}</span> &nbsp;&nbsp;
                        负责人姓名：<span>{{ userInfo.chargePerson }}</span>
                        <!-- <el-input disabled class="input-with-select" style="max-width: 200px"></el-input> -->
                        &nbsp;&nbsp;
                        负责人电话：<span>{{ userInfo.chargePersonPhone }}</span>
                        <!-- <el-input disabled class="input-with-select" style="max-width: 200px"></el-input>&nbsp;&nbsp; -->
                        <!-- <el-button style="margin-left:20px" type="primary" plain @click="search">搜 索</el-button>
                        <el-button style="margin-left:20px" type="primary" plain @click="reset">重 置</el-button>
                        <el-button style="margin-left:20px" type="primary" @click="openDeriveFile" plain>全部导出</el-button> -->
                        <el-button style="margin-left:20px" type="primary" @click="returnPage" plain>返回</el-button>
                    </div>
                    <hr style="margin-top: 20px" />
                </div>
                <br />
            </div>
            <br />
            <div id="echarts"></div>
            <!-- <div @click="export2Excel">导出表格</div> -->
            <div class="global-table-box">
                <div class="size">
                    <p>商品明细</p>
                    <el-table :data="list" border style="width: 100%;" tooltip-effect="dark" :cell-style="{}">
                        <el-table-column type="index" width="50" label="#" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column prop="goodsName" label="商品名称" width="270" align="center" header-align="center">
                        </el-table-column>
                        <el-table-column prop="number" label="订购数量(件)" align="center" header-align="center"
                            max-width="500px">
                        </el-table-column>
                        <el-table-column prop="originalTotal" label="单价(元)" align="center" header-align="center"
                            max-width="500px">
                        </el-table-column>
                        <el-table-column prop="orderTotal" label="总金额(元)" align="center" header-align="center"
                            max-width="500px">
                        </el-table-column>
                        <!-- <el-table-column prop="quantity" label="数量" align="center" header-align="center" max-width="500px">
                        </el-table-column>
                        <el-table-column prop="salesVolume" label="订购金额(元)" width="200" header-align="center"
                            align="center">
                        </el-table-column>
                        <el-table-column prop="goodsModel" label="款式" align="center" header-align="center"
                            max-width="500px">
                        </el-table-column>
                        <el-table-column prop="remark" label="身高/尺寸" width="200" header-align="center" align="center">
                        </el-table-column> -->

                    </el-table>
                </div>

            </div>
            <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="schoolInfo.pageNum"
                    layout="prev, pager, next, jumper" :total="totalPage" :page-size="schoolInfo.pageSize">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
import * as echarts from 'echarts';
import { inquireCampusDetails } from "../Api/campusDetails"
export default {
    name: 'UniformVueCampusDetails',

    data() {
        return {
            schoolInfo: {
                isPage: true,
                pageNum: 1,
                pageSize: 10,
                schoolId: ""
            },
            list: [],
            userInfo: {},
            totalPage: 1,
            isEcharts: true
        };
    },
    created() {
        this.schoolInfo.schoolId = this.$route.query.id
        this.queryDetails()
    },
    mounted() {
        // this.echartsList()
    },

    methods: {
        // echarts图表
        echartsList(source) {
            let chartDom = document.getElementById('echarts');
            let myChart = echarts.init(chartDom, null, {
                renderer: 'svg'
            });
            let option;

            option = {
                legend: {},
                tooltip: {},
                dataset: {
                    source
                },
                xAxis: {
                    type: 'category',
                },
                yAxis: {
                    type: 'log',
                    min: 1
                },
                // Declare several bar series, each will be mapped
                // to a column of dataset.source by default.
                series: [
                    {
                        type: 'bar', barWidth: '25px', label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'black',//字体颜色
                                fontSize: 10//字体大小
                            }
                        }
                    },
                    {
                        type: 'bar', barWidth: '25px', label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'black',//字体颜色
                                fontSize: 10//字体大小
                            }
                        }
                    },
                    {
                        type: 'bar', barWidth: '25px', label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            textStyle: { //数值样式
                                color: 'black',//字体颜色
                                fontSize: 10//字体大小
                            }
                        }
                    },
                    // { type: 'bar', barWidth: '25px' },
                    // { type: 'bar', barWidth: '25px' }
                ]
            };

            option && myChart.setOption(option);

        },
        //查询数据
        async queryDetails() {
            const res = await inquireCampusDetails(this.schoolInfo)
            if (res.code === '200') {
                this.userInfo = res.data
                this.list = res.data && res.data.schoolDetailsListVoList
                this.totalPage = res.data.totalPage
                let echartsData = [['product', '商品单价', '销售数量', '总销售额'],]

                if (res.data.schoolDetailsListVoList.length > 0) {
                    this.isEcharts = true
                    res.data.schoolDetailsListVoList.forEach(item => {
                        let arr = [item.goodsName, item.originalTotal, item.number, item.orderTotal]
                        echartsData.push(arr)
                    });
                    this.echartsList(echartsData)
                } else {
                    this.isEcharts = false
                }
            }
        },
        // 返回上一页
        returnPage() {
            this.$router.go(-1)
        },
        // 分页
        handleCurrentChange() {
            this.queryDetails()
        }
    },
};
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
}

.gross-container {
    width: 300px;
    height: 100px;
    background-color: #000;
    text-align: center;
    padding: 20px 0;
    color: #fff;
}

.condition {
    display: flex;
    line-height: 30px;

    span {
        min-width: 200px;
        height: 30px;
        display: inline-block;
        background-color: #e0e0e0;
        text-align: left;
        padding: 0 0 0 10px;
        box-sizing: border-box;
        border-radius: 5px;
    }
}

.herd {
    display: flex;
    justify-content: space-between;
}

.block {
    text-align: right;
    background-color: #fff;
}

.size {
    padding: 0 50px;

    p {
        font-weight: bold;
        margin: 10px 0;
        font-size: 20px;
    }

    table {
        border-collapse: collapse;
    }

    table,
    th,
    td {
        border: 1px solid #e0e0e0;
        text-align: center;
        width: 600px;
        padding: 5px 0;
    }
}

#echarts {
    // width: 1000px;
    height: 500px;
    background-color: #fff;
    border-radius: 5px;
}
</style>